export default __webpack_public_path__ + "static/media/Carnas-W03-Regular.dd592c24.ttf";